import React from 'react'
import Svg from './Svg'
export const SvgNote = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M6.7.7L.7 7C.2 7.5 0 8 0 8.7v12.9C0 22.9 1.1 24 2.4 24h19.2c1.3 0 2.4-1.1 2.4-2.4V2.4C24 1.1 22.9 0 21.6 0H8.4c-.7 0-1.3.3-1.7.7zm.5 3v3.8H3.5l3.7-3.8zm14.4 17.9H2.4V9.9h6c.7 0 1.2-.5 1.2-1.2V2.4h12v19.2z" />
  </Svg>
))
SvgNote.isIcon = true
export default SvgNote
